import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutContent from "@/pages/about.md";
//import AboutContentShort from "@/pages/aboutShort.md";
import ValuesContent from "@/pages/values.md";
//import DetailsContent from "@/pages/details.md";
//import Details from "@/pages/details.vue";
import ConceptsContent from "@/pages/concepts.md";
//import Join from "@/pages/join.vue";
import MusicContent from "@/pages/music.md";
//-import Hello from '@/pages/Hello'

const About = { template: AboutContent }
const Concepts = { template: ConceptsContent }
const Values = { template: ValuesContent }
const Music = { template: MusicContent }
//const Details = { template: DetailsContent }

Vue.use(VueRouter)

const routes = [
  {
  path: '/',
  name: 'About',
  component: About,
 },  {
  path: '/music',
  name: 'Music',
  component: Music,
 }, 
  {
  path: '/values',
  name: 'Values',
  component: Values,
 }, 
{
  path: '/Concepts',
  name: 'concepts',
  component: Concepts,
 }, 
 /*
 {
  path: '/Join',
  name: 'Join',
  component: Join,
 }, 
 
 {
  path: '/go',
  name: 'Details',
  component: Details,
 }, 
 */
]

const router = new VueRouter({
  routes, mode: "history"
})

export default router
